<template>
  <CustomPage :noTitle="true">
    <div slot="content" class="content">
      <CustomHead
        title="好评TOP榜单"
        backgroundColor="#fff"
        fontColor="black"
        :boxShadow="true"
        ref="CustomHead"
        @sharePoster="sharePoster"
      />
      <div class="scroll-wrapper">
        <Tabs
          v-model="active"
          scrollspy
          sticky
          :offset-top="tabs_height"
          :swipe-threshold="3"
        >
          <Tab
            v-for="item in data"
            :title="item.themeName"
            :key="item.actThemeId"
          >
            <Panel :data="item" />
          </Tab>
        </Tabs>
      </div>
      <CustomView />
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from '@/components/custom-page.vue'
import CustomView from '@/components/custom-view.vue'
import CustomHead from '@/components/custom-head'
import Panel from './components/Panel'
import { getTopList } from '@/api/topList'
import { topShare } from '@/api/forward'
import { Tabs, Tab } from 'vant'
export default {
  components: { CustomPage, CustomView, Tabs, Tab, CustomHead, Panel },
  data() {
    return {
      tabs_height: 0,
      active: 0,
      data: [],
    }
  },
  created() {
    this.getData()
  },
  mounted() {
    this.tabs_height = this.$refs.CustomHead.$el.offsetHeight + 0.5
  },
  methods: {
    sharePoster() {
      let forwardUrl = `${window.location.origin}/topList?customerId=${this.$store.state.user.forwardId}`
      this.$store.dispatch('app/showLoading')
      topShare({ url: forwardUrl })
        .then((res) => {
          this.$store.dispatch('app/hideLoading')

          this.sharePosterOpen(res.data, forwardUrl)
        })
        .catch(() => {
          this.$store.dispatch('app/hideLoading')
        })
    },
    sharePosterOpen(url, forwardUrl) {
      this.$store.dispatch('sharePoster/show', {
        url,
        title: '好评TOP榜',
        desc: '好评TOP榜',
        link: forwardUrl,
        imgUrl: '',
      })
    },
    getData() {
      this.$store.dispatch('app/showLoading')
      getTopList()
        .then((res) => {
          this.data = res.data
          this.$store.dispatch('app/hideLoading')
        })
        .catch(() => {
          this.$store.dispatch('app/hideLoading')
        })
    },
  },
}
</script>

<style lang="less" scoped>
.content {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #f7b500;
  padding-top: 100px;
  .scroll-wrapper {
    position: relative;
    flex: 1;
    min-height: 0;
    .van-tabs {
      & /deep/ .van-sticky {
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.14);
        transform: translateZ(10);
        .van-tabs__wrap {
          box-shadow: 0 -1px 1px #fff;
          height: 76px;
          .van-tab {
            padding: 0 12px;
            color: #e82035;
            transition: 0.1s;
            &.van-tab--active {
              color: #fff;
              background-color: #e82035;
            }
          }
          .van-tabs__line {
            display: none;
          }
        }
      }
      & /deep/ .van-tabs__content {
        background-color: #f7b500;
        padding-bottom: 100px;
      }
    }
  }
}
.custom-head {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
}
</style>
